import type { CodeSnippetDropZone, CodeSnippetDropZoneMode, CodeSnippetPlacementFilter } from '../types';

export const EXECUTION_MODEL_DROP_ZONES: readonly CodeSnippetDropZone[] = ['top-level-setup', 'action-group'];

const IMMEDIATE_CODE_FILTERS: readonly CodeSnippetDropZone[] = ['top-level-setup'];
const ROBOT_BASE_ACTION_FILTERS: readonly CodeSnippetDropZone[] = ['action-group'];
const CONTEXTUAL_FILTERS = EXECUTION_MODEL_DROP_ZONES;

export const codeTypeFiltersForDropZone = (dropZone: CodeSnippetDropZoneMode | undefined): readonly CodeSnippetDropZone[] => {
  if (dropZone === 'top-level-setup') return IMMEDIATE_CODE_FILTERS;
  if (dropZone === 'action-group') return ROBOT_BASE_ACTION_FILTERS;
  if (dropZone === 'contextual') return CONTEXTUAL_FILTERS;
  return [];
};

export const codeTypeMatchesDropZone = (
  dropZone: CodeSnippetDropZoneMode | undefined,
  placementFilter: CodeSnippetPlacementFilter | undefined
): boolean => placementFilter == null || placementFilter === 'all' || codeTypeFiltersForDropZone(dropZone).includes(placementFilter);

export const aggregateExecutionModelForDropZone = (
  dropZone: CodeSnippetDropZoneMode | undefined,
  placementFilter: CodeSnippetPlacementFilter | undefined
): CodeSnippetDropZone | null => {
  if (dropZone === 'top-level-setup' || dropZone === 'action-group') return dropZone;
  if (dropZone === 'contextual') return placementFilter === 'action-group' ? 'action-group' : 'top-level-setup';
  return null;
};
